

















import { defineComponent } from '@vue/composition-api';
import HelpMenu from './HelpMenu.vue';
import ModelStatisticsMenu from './ModelStatisticsMenu.vue';
import { helpDialog, modelStatisticsDialog } from '../state';

export default defineComponent({
  name: 'About',
  components: { HelpMenu, ModelStatisticsMenu },
  setup() {
    return { helpDialog, modelStatisticsDialog };
  },
});
